import TaboolaTrack from '../components/taboola-track';

const config = () => window.taboolaConfig || {};

// Start tracking after the first completed form step.
export default class TaboolaPetFormTracker {
    constructor() {
        this.started = false;
        this.completed = false;
    }
    isEnabled() {
        return config().quizEnabled && config().quizSource === 'pet-form';
    }
    start() {
        if (!this.isEnabled() || this.started || this.completed) return;
        this.started = true;
        TaboolaTrack.send('QuizStart');
        TaboolaTrack.post('taboola-quiz-track', {});
    }
    complete() {
        if (!this.isEnabled() || this.completed) return;
        this.completed = true;
        TaboolaTrack.send('QuizComplete');
    }
}
